import { css } from "@emotion/react";
import { useRestorePurchases } from "@sharpana/payments/useRestorePurchases";

const action = css`
  background: none;
  border: none;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  text-decoration: underline;
  cursor: pointer;
  padding: 0.25rem 0.5rem;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const note = css`
  max-width: 34rem;
  text-align: center;
  font-size: 0.9rem;
  line-height: 1.5;
  white-space: pre-line;
  color: var(--color-text-secondary);
  background: var(--color-success-bg);
  border: 1px solid var(--color-success-border);
  border-radius: 8px;
  padding: 0.75rem 1rem;
`;

const failure = css`
  ${note};
  color: var(--color-warning-text);
  background: var(--color-warning-bg);
  border-color: var(--color-warning-border);
`;

/**
 * Re-sync purchases made on another device or before a reinstall.
 *
 * Apple requires a restore path in any app selling non-consumables, so this
 * sits on both the paywall and settings. The call itself is shared
 * (`useRestorePurchases`); the wording is the coaching product's.
 */
export function RestorePurchases() {
  const { loading, error, result, restore } = useRestorePurchases();

  return (
    <>
      <button css={action} onClick={restore} disabled={loading}>
        {loading ? "Restoring purchases…" : "Restore purchases"}
      </button>

      {error && (
        <p css={failure}>
          We could not restore your purchases just now. Please try again, or
          contact support@mrble.ai if it keeps happening.
        </p>
      )}

      {!error && result && (
        <p css={note}>
          {result.activeSubscriptionSkuNames.length > 0
            ? `Restored. Active: ${result.activeSubscriptionSkuNames.join(", ")}`
            : `Restored. Your credit balance is ${result.balance}.`}
          {"\n"}Purchases are tied to your account, not to this device.
        </p>
      )}
    </>
  );
}
